import React from 'react'
import TextField from "../../../fields/TextField";
import SelectField from "../../../fields/SelectField";
import { buildOptions } from "../../../utils"
import { useSelector } from 'react-redux';

export function MedicalHistory() {
  const substances_of_choice_options = useSelector(state => buildOptions(state.org_dependant_data.substances_of_choice_options))
  const mental_disorders_options = useSelector(state => buildOptions(state.org_dependant_data.mental_disorders_options))
  const health_problem_options = useSelector(state => buildOptions(state.org_dependant_data.health_problem_options))
  const allergies_options = useSelector(state => buildOptions(state.org_dependant_data.allergies_options))

  return (
    <div className="p-4">
      <SelectField
        name="diagnosis_list"
        label="Diagnosis"
        action="edit"
        col="none"
        options={mental_disorders_options}
        creatable
        isMulti />
      <SelectField
        name="substances_of_choice_list"
        label="Substances of Choice"
        action="edit"
        col="none"
        options={substances_of_choice_options}
        creatable
        isMulti />
      <SelectField
        name="health_problem_list"
        label="Health Problems"
        action="edit"
        col="none"
        options={health_problem_options}
        creatable
        isMulti />
      <SelectField
        name="allergy_type_list"
        label="Allergies"
        action="edit"
        col="none"
        options={allergies_options}
        creatable
        isMulti />
      <TextField name="medical_notes" label="Notes" action="edit" col="none" />
    </div>
  )
}
